// extracted by mini-css-extract-plugin
export default {"page":"ApiPage_page__ynJ+q","container":"ApiPage_container__rw2iA"};